import { render, staticRenderFns } from "./LocationSearchDialog.vue?vue&type=template&id=b2f2b1da&"
import script from "./LocationSearchDialog.vue?vue&type=script&lang=js&"
export * from "./LocationSearchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2f2b1da')) {
      api.createRecord('b2f2b1da', component.options)
    } else {
      api.reload('b2f2b1da', component.options)
    }
    module.hot.accept("./LocationSearchDialog.vue?vue&type=template&id=b2f2b1da&", function () {
      api.rerender('b2f2b1da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/LocationSearchDialog.vue"
export default component.exports